import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Observable } from 'rxjs';

import { Feature, FeatureNames, IsActiveProperty } from '@vi-iot/client';

import { InstallationFeaturesStore } from '@store';

import { HeatingPanelService } from './heating-panel.service';

@Component({
  selector: 'app-heating-panel',
  templateUrl: './heating-panel.component.html',
  styleUrls: ['./heating-panel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeatingPanelComponent implements OnInit, OnDestroy {
  isMultiFamily$: Observable<Feature<IsActiveProperty, never>>;

  @Input() circuitId: string;

  constructor(
    private installationFeaturesStore: InstallationFeaturesStore,
    private heatingPanelService: HeatingPanelService
  ) {}

  ngOnInit(): void {
    this.heatingPanelService.initFeatures(this.circuitId);
    this.heatingPanelService.initHeatingModes();
    this.isMultiFamily$ = this.installationFeaturesStore.selectInstallationDeviceFeature(
      FeatureNames.configurationMultiFamilyHouse
    );
  }

  ngOnDestroy(): void {
    this.heatingPanelService.ngUnsubscribe.next();
    this.heatingPanelService.ngUnsubscribe.complete();
  }
}
